import { render, staticRenderFns } from "./ResetPasswordSent.vue?vue&type=template&id=26689c14&"
import script from "./ResetPasswordSent.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports